const findScrollableParent = (element: HTMLElement): HTMLElement | null => {
  let parent = element.parentElement;
  while (parent && parent !== document.body) {
    const { overflowY } = window.getComputedStyle(parent);
    if (
      (overflowY === 'auto' || overflowY === 'scroll') &&
      parent.scrollHeight > parent.clientHeight
    ) {
      return parent;
    }
    parent = parent.parentElement;
  }
  return null;
};

export const scrollToStartOfDiv = (
  ref: React.RefObject<HTMLElement | null>,
  offsetInPx = 0,
) => {
  const element = ref.current;
  if (!element) return;

  const doScroll = () => {
    const scrollParent = findScrollableParent(element);

    if (scrollParent) {
      const parentRect = scrollParent.getBoundingClientRect();
      const elementRect = element.getBoundingClientRect();
      const top =
        scrollParent.scrollTop + elementRect.top - parentRect.top - offsetInPx;
      scrollParent.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      return;
    }

    const elementRect = element.getBoundingClientRect();
    const top = elementRect.top + window.scrollY - offsetInPx;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  };

  requestAnimationFrame(doScroll);
};

export const scrollToElementById = (id: string, offsetInPx?: number) => {
  const element = document.getElementById(id);
  if (!element) return;
  scrollToStartOfDiv({ current: element }, offsetInPx);
};
